module.exports = __webpack_public_path__ + "static/affiliate/affiliate-insurance-57ddee48322f00740fc7f81dcd0ee5c2.jpg";